const convertPrice = (spare) => {
  return spare.preco?.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};

export default convertPrice;
